import type { SelfUser } from "~/stores/user";
import type { RouterInputs, RouterOutputs } from "~/utils/api";

export const TRACK_EVENTS = {
	AUTH: "AUTH",
	CREATE_ROOM: "CREATE_ROOM",
	JOIN_ROOM: "JOIN_ROOM",
	LEAVE_ROOM: "LEAVE_ROOM",
	TRANSCRIBER: "TRANSCRIBER",
} as const;

export interface TRACK_EVENT_TYPE {
	[TRACK_EVENTS.AUTH]: {
		user?: SelfUser;
		status: "login" | "logout" | "error";
		error?: unknown;
	};
	[TRACK_EVENTS.CREATE_ROOM]: {
		status: "creating" | "created" | "error";
		error?: unknown;
	} & Partial<RouterInputs["room"]["create"]> &
		Partial<RouterOutputs["room"]["create"]>;
	[TRACK_EVENTS.JOIN_ROOM]: {
		roomId: string;
	};
	[TRACK_EVENTS.LEAVE_ROOM]: {
		roomId: string;
	};
	[TRACK_EVENTS.TRANSCRIBER]: {
		roomId: string;
		status: "start" | "stop" | "error";
		error?: unknown;
	};
}
